import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './Dropdown.module.css';
import { Check, ChevronDown } from 'lucide-react';
const Dropdown = ({
    value,
    onChange,
    options = [],
    placeholder = 'Select an option',
    className = ''
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const handleToggle = () => {
        setIsOpen(prev => !prev);
    };

    const handleOptionClick = (option) => {
        onChange(option);
        setIsOpen(false);
    };

    const selectedOption = options.find(opt => opt.value === value);
    const displayText = selectedOption ? selectedOption.label : placeholder;

    return (
        <div className={`${styles.dropdown} ${className}`} ref={dropdownRef}>
            <button
                type="button"
                className={styles.dropdownToggle}
                onClick={handleToggle}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
            >
                <span className={styles.dropdownValue}>{displayText}</span>
                <ChevronDown
                    className={`${styles.dropdownArrow} ${isOpen ? styles.open : ""}`}
                    size={16}         // Any size you want
                    color="#999"      // Or your theme color
                    aria-hidden="true"
                />
            </button>

            {isOpen && (
                <ul className={styles.dropdownMenu} role="listbox">
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={`${styles.dropdownOption} ${option.value === value ? styles.selected : ''
                                }`}
                            onClick={() => handleOptionClick(option)}
                            role="option"
                            aria-selected={option.value === value}
                        >
                            {option.label}
                            {option.value === value && (
                                <Check
                                    className={styles.checkIcon}
                                    size={16}
                                    color="currentColor"
                                    aria-hidden="true"
                                />
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

Dropdown.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
};

export default Dropdown;
